import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';

import type { ListColumnFilters } from './listUrlState';

export const linkedToActiveTodayKey = 'linkedToActiveToday';

const linkedToActiveTodayFilter = ['TRUE'];

export const linkedToActiveTodayFilterValue = (on: boolean): string[] | null => (on ? linkedToActiveTodayFilter : null);

export const isLinkedToActiveTodayOnly = (filters: ListColumnFilters): boolean => {
  const applied = filters[linkedToActiveTodayKey];

  return Array.isArray(applied) && applied.length === 1 && applied[0] === linkedToActiveTodayFilter[0];
};

/** The Yes/No column the linked-to-active-today switch drives, through its filter. */
export const linkedToActiveTodayColumn = <T>(title: string, width = 200): TableColumns<T>[number] => ({
  title,
  dataIndex: linkedToActiveTodayKey,
  key: linkedToActiveTodayKey,
  options: {
    format: {
      type: 'boolean',
    },
    filter: 'select',
    listName: FieldType.YES_NO,
  },
  width,
});
